/* eslint-disable @next/next/no-img-element */
'use client';

import classNames from 'classnames';

import {
    FooterAboutLinks,
    FooterUdemyBusinessLinks,
    FooterLegalLinks,
    FooterDiscoverLinks,
    LogoSectionMobile,
} from './footer.common';
import styles from './footer.module.scss';
import {useI18n} from '@udemy-v2/i18n';
import {FooterSkillsAccordion} from './footer-skills-accordion.react-component';

export function FooterMobile() {
    const {gettext} = useI18n();
    return (
        <footer className={classNames('ud-color-scheme-dark', styles['footer-container'])}>
            <div className={styles['notice-container-mobile']}>
                <div className={`${styles.notice} ud-heading-lg`}>
                    {gettext('Top companies choose ')}
                    <a
                        data-purpose="ufb-link"
                        className={styles.invertedLink}
                        href="/udemy-business/?locale=en_US&mx_pg=indeed-page&path=%2F&ref=footer"
                        target="_blank"
                        rel="noopener"
                    >
                        {gettext('Udemy Business')}
                    </a>{' '}
                    {gettext('to build in-demand career skills.')}
                </div>
                <div className={styles['partner-logos']}>
                    <img
                        className={styles['partner-logo-mobile']}
                        src="https://s.udemycdn.com/partner-logos/v4/nasdaq-light.svg"
                        alt="Nasdaq"
                        height="44"
                        width="115"
                        loading="lazy"
                    />
                    <img
                        className={styles['partner-logo-mobile']}
                        src="https://s.udemycdn.com/partner-logos/v4/volkswagen-light.svg"
                        alt="Volkswagen"
                        height="44"
                        width="44"
                        loading="lazy"
                    />
                    <img
                        className={styles['partner-logo-mobile']}
                        src="https://s.udemycdn.com/partner-logos/v4/netapp-light.svg"
                        alt="NetApp"
                        height="44"
                        width="115"
                        loading="lazy"
                    />
                    <img
                        className={styles['partner-logo-mobile']}
                        src="https://s.udemycdn.com/partner-logos/v4/eventbrite-light.svg"
                        alt="Eventbrite"
                        height="44"
                        width="115"
                        loading="lazy"
                    />
                </div>
            </div>
            <FooterSkillsAccordion />

            <div className={styles['footer-section-group-mobile']}>
                <div className={styles['footer-section-group-column-mobile']}>
                    <div className={styles['footer-section-group-column-title']}>
                        {gettext('About')}
                    </div>
                    <FooterAboutLinks />
                </div>
                <div className={styles['footer-section-group-column-mobile']}>
                    <div className={styles['footer-section-group-column-title']}>
                        {gettext('Discover Udemy')}
                    </div>
                    <FooterDiscoverLinks />
                </div>{' '}
                <div className={styles['footer-section-group-column-mobile']}>
                    <div className={styles['footer-section-group-column-title']}>
                        {gettext('Udemy for Business')}
                    </div>
                    <FooterUdemyBusinessLinks />
                </div>{' '}
                <div className={styles['footer-section-group-column-mobile']}>
                    <div className={styles['footer-section-group-column-title']}>
                        {gettext('Legal & Accessibility')}
                    </div>
                    <FooterLegalLinks />
                </div>
            </div>
            <LogoSectionMobile />
        </footer>
    );
}
